import React from 'react';
import DimpleDivider from '@tds/core-dimple-divider';
import { orderPermissionsData } from './orderPermissionsData';

import Block from './components/block';

const OrderPermissions = () => {
  return (
    <>
      <div className="layout-container">
        <DimpleDivider />
        <Block data={orderPermissionsData} />
      </div>
    </>
  );
};

export default OrderPermissions;
